import { Colors, PrimaryButton, Link, Text } from 'library';
import React, { useState } from 'react';
import { Grid, styled, useMediaQuery } from '@mui/material';
import { formatMonthDayYearWith12HourTime } from 'shared/Dates';
import { client, consoleLogInDev } from 'shared';
import { ISentHomeAppointment } from 'models';
import theme from 'theme';
import { SentHomeDisputeModal } from './SentHomeDisputeModal';

interface SentHomeCancelsProps {
    overallReasons: ISentHomeAppointment[];
    refreshReasons: () => void;
}

export default function SentHomeCancels({ overallReasons, refreshReasons }: SentHomeCancelsProps) {
    const [disputeId, setDisputeId] = useState<number>();
    const [disputeName, setDisputeName] = useState('');

    const isXs = useMediaQuery(theme.breakpoints.down('sm'));

    function onConfirmOrDenyClick(id: number, sentHome: boolean) {
        client('api/sub-shifts/confirm-sent-home/', { body: { appointment_id: id, was_sent_home: sentHome } })
            .then(() => refreshReasons())
            .catch(consoleLogInDev);
    }

    return (
        <Grid>
            <Text variant="h2" bold>
                Workers Marked Sent Home ({overallReasons.length})
            </Text>
            <Text variant="body2" textStyle={{ marginTop: 5 }}>
                Please confirm if you sent these workers home.
            </Text>
            <StyledContainer container>
                {overallReasons.map((x) => (
                    <ItemContainer key={x.id} container item sm={4} xs={12} isXs={isXs}>
                        <Grid item xs={12}>
                            <Text>
                                <b>Name:</b> {x.provider_name}
                            </Text>
                        </Grid>
                        <Grid item xs={12}>
                            <Text>
                                <b>Shift Date:</b> {formatMonthDayYearWith12HourTime(x.start_date, x.timezone)}
                            </Text>
                        </Grid>
                        <Grid container direction="row" style={{ marginTop: 10 }}>
                            <Grid container item xl={5} xs={8} alignItems="center" style={{ marginBottom: 10 }}>
                                <PrimaryButton onClick={() => onConfirmOrDenyClick(x.id, true)}>
                                    I sent them home
                                </PrimaryButton>
                            </Grid>
                            <LeftMarginContainer container item xl={5} alignItems="center">
                                <Link onClick={() => onConfirmOrDenyClick(x.id, false)}>They did not show</Link>
                            </LeftMarginContainer>
                            <Grid container justifyContent="flex-end" xs={12}>
                                <Link
                                    onClick={() => {
                                        setDisputeId(x.id);
                                        setDisputeName(x.provider_name);
                                    }}
                                    style={{ color: Colors.terraCotta }}
                                >
                                    Dispute
                                </Link>
                            </Grid>
                        </Grid>
                    </ItemContainer>
                ))}
            </StyledContainer>
            <SentHomeDisputeModal
                small={isXs}
                isOpen={Boolean(disputeId)}
                onClose={() => {
                    setDisputeId(undefined);
                    setDisputeName('');
                }}
                onSubmit={() => {
                    setDisputeId(undefined);
                    refreshReasons();
                }}
                appointmentId={disputeId}
                workerName={disputeName}
            />
        </Grid>
    );
}

const StyledContainer = styled(Grid)({
    padding: '10px 0',
});

const LeftMarginContainer = styled(Grid)({
    marginLeft: 20,
});

const ItemContainer = styled(Grid)<{ isXs: boolean }>(({ isXs }) => ({
    padding: isXs ? '3%' : '1%',
    backgroundColor: 'white',
    borderRadius: 20,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    border: `solid 1px ${Colors.lightGrey}`,
}));
